module.exports = __webpack_public_path__ + "static/media/night-driving-dark.28f4a38e.svg";